import {httpClientV2} from "../../../../infrastructure/http";
import {
  WithdrawableBalance,
  PendingBalance,
  PaginatedPayoutHistory,
  PaginationParams,
  PayoutRepository,
} from "../../domain/types";
import {PayoutMapperV2} from "../mappers/mapper.v2";
import {
  V2WithdrawableBalanceResponse,
  V2PendingBalanceResponse,
  V2PayoutHistoryResponse,
} from "../mappers/mapper.types";

/**
 * v2 API implementation of PayoutRepository.
 *
 * Endpoints:
 * - GET payments/analytics/withdrawable/balance
 * - GET payments/analytics/pending/balance
 * - GET payments/analytics/payouts/history?page=&perPage=
 *
 * Pure TypeScript - no React imports.
 */
export class PayoutRepositoryV2 implements PayoutRepository {
  private readonly balanceEndpoint = "payments/analytics/withdrawable/balance";
  private readonly pendingEndpoint = "payments/analytics/pending/balance";
  private readonly historyEndpoint = "payments/analytics/payouts/history";

  async getWithdrawableBalance(): Promise<WithdrawableBalance> {
    const response = await httpClientV2.get<V2WithdrawableBalanceResponse>(
      this.balanceEndpoint
    );
    return PayoutMapperV2.toWithdrawableBalance(response.data);
  }

  async getPendingBalance(): Promise<PendingBalance> {
    const response = await httpClientV2.get<V2PendingBalanceResponse>(
      this.pendingEndpoint
    );
    return PayoutMapperV2.toPendingBalance(response.data);
  }

  async getPayoutHistory(params?: PaginationParams): Promise<PaginatedPayoutHistory> {
    const queryParams = new URLSearchParams();
    if (params?.page !== undefined) {
      queryParams.append("page", params.page.toString());
    }
    if (params?.perPage !== undefined) {
      queryParams.append("perPage", params.perPage.toString());
    }

    const queryString = queryParams.toString();
    const url = queryString
      ? `${this.historyEndpoint}?${queryString}`
      : this.historyEndpoint;

    const response = await httpClientV2.get<V2PayoutHistoryResponse>(url);
    return PayoutMapperV2.toPayoutHistory(response.data);
  }
}
